"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WebmasterCandidateComponent = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WebmasterCandidate = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(WebmasterCandidate, _Component);

  var _super = _createSuper(WebmasterCandidate);

  function WebmasterCandidate(props) {
    var _this;

    (0, _classCallCheck2.default)(this, WebmasterCandidate);
    _this = _super.call(this, props);
    _this.state = {
      email: props.email,
      sendLoading: false,
      deleteLoading: false,
      error: null
    };
    return _this;
  }

  (0, _createClass2.default)(WebmasterCandidate, [{
    key: "sendEmail",
    value: function () {
      var _sendEmail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.state.email) {
                  _context.next = 11;
                  break;
                }

                this.setState({
                  sendLoading: true
                });
                _context.prev = 2;
                _context.next = 5;
                return _axios.default.post('/settings/emailManagement/sendVerificationMail', {
                  email: this.state.email
                });

              case 5:
                this.setState({
                  sendLoading: false
                }, function () {
                  window.location.reload();
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                this.setState({
                  sendLoading: false,
                  error: _context.t0.response ? _context.t0.response.data.error : 'Something went wrong. Please, refresh the page and try again.'
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function sendEmail() {
        return _sendEmail.apply(this, arguments);
      }

      return sendEmail;
    }()
  }, {
    key: "deleteEmail",
    value: function () {
      var _deleteEmail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  deleteLoading: true
                });
                _context2.prev = 1;
                _context2.next = 4;
                return _axios.default.post('/settings/emailManagement/deleteCandidate', {
                  email: this.props.email
                });

              case 4:
                this.setState({
                  deleteLoading: false
                });
                this.props.onDelete();
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  deleteLoading: false,
                  error: 'Something went wrong. Please, refresh the page and try again.'
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function deleteEmail() {
        return _deleteEmail.apply(this, arguments);
      }

      return deleteEmail;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      return (0, _preact.h)(WebmasterCandidateComponent, (0, _extends2.default)({}, state, props, {
        email: props.email || state.email,
        onChange: function onChange(val) {
          return _this2.setState({
            email: val
          });
        },
        sendVerificationEmail: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this2.sendEmail();

                case 2:
                  return _context3.abrupt("return", _context3.sent);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })),
        deleteEmail: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this2.deleteEmail();

                case 2:
                  return _context4.abrupt("return", _context4.sent);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))
      }));
    }
  }]);
  return WebmasterCandidate;
}(_preact.Component);

var WebmasterCandidateComponent = function WebmasterCandidateComponent(props) {
  return (0, _preact.h)("div", {
    className: "item row"
  }, props.error ? (0, _preact.h)("div", {
    className: "alert alert-danger"
  }, props.error) : null, (0, _preact.h)("input", {
    id: "email",
    className: "js-email",
    type: "email",
    placeholder: "info@example.com",
    value: props.email,
    onChange: function onChange(event) {
      return props.onChange(event.target.value);
    }
  }), props.showSendButton ? (0, _preact.h)(_buttonControl.default, {
    variant: "success",
    title: "Send verification mail",
    isLoading: props.sendLoading,
    onClick: props.sendVerificationEmail
  }) : null, props.showDeleteButton ? (0, _preact.h)(_buttonControl.default, {
    variant: "danger",
    title: "Delete email-address",
    isLoading: props.deleteLoading,
    onClick: props.deleteEmail
  }) : null);
};

exports.WebmasterCandidateComponent = WebmasterCandidateComponent;
var _default = WebmasterCandidate;
exports.default = _default;